import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — a classical round column for porticos and colonnades: a
// square base plinth, a gently tapered round shaft and a square capital,
// 2.6 m tall (one storey) in an off-white stone tone.
const OFFWHITE = "#efece4";
const OFFWHITE_DARK = "#ddd8cc";

export const columnRound = defineModel({
  id: "column-round",
  batchId: "modern",
  name: "Round column",
  tags: ["modern", "interior", "outdoor", "structure", "column", "classical", "portico"],
  summary: "A classical off-white round column with plinth and capital, 2.6 m tall.",
  description:
    "A one-tile classical column of the Modern Living kit: a square base " +
    "plinth, a tapered round shaft and a square capital, one storey (2.6 m) " +
    "tall in off-white stone. Suits porticos, colonnades and civic fronts.",
  tiles: { w: 1, h: 1 },
  footprint: 1.4,
  parts(): Part[] {
    return [
      // square base plinth
      { geometry: new THREE.BoxGeometry(0.46, 0.1, 0.46), color: OFFWHITE_DARK, position: [0, 0.05, 0] },
      // round base torus (a squat cylinder)
      { geometry: new THREE.CylinderGeometry(0.2, 0.21, 0.08, 14), color: OFFWHITE, position: [0, 0.14, 0] },
      // tapered shaft (0.18 -> 2.4)
      { geometry: new THREE.CylinderGeometry(0.14, 0.17, 2.22, 14), color: OFFWHITE, position: [0, 1.29, 0] },
      // capital neck (echinus)
      { geometry: new THREE.CylinderGeometry(0.19, 0.15, 0.1, 14), color: OFFWHITE, position: [0, 2.45, 0] },
      // square capital slab (abacus) up to 2.6
      { geometry: new THREE.BoxGeometry(0.42, 0.1, 0.42), color: OFFWHITE_DARK, position: [0, 2.55, 0] },
    ];
  },
  animations: [],
});
